import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useSettingsContext } from 'context/useSettingsContext';
import { Dropdown } from 'react-bootstrap';
import React from 'react';

type ActionDropdownProps = {
  btnRevealClass?: string;
  drop?: 'up' | 'down' | 'start' | 'end';
  children: React.ReactNode;
  icon?: any;
};

export default function ActionDropdown({
  btnRevealClass,
  drop,
  children,
  icon = 'ellipsis-h'
}: ActionDropdownProps) {
  const {
    config: { isRTL }
  } = useSettingsContext();

  return (
    <Dropdown
      className="font-sans-serif btn-reveal-trigger"
      align={isRTL ? 'start' : 'end'}
      drop={drop}
    >
      <Dropdown.Toggle
        variant="link"
        size="sm"
        data-boundary="viewport"
        className={classNames('text-600', {
          ...(btnRevealClass ? { [btnRevealClass]: true } : {}),
          'btn-reveal': !btnRevealClass
        })}
      >
        <FontAwesomeIcon icon={icon} className="fs--2" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="border py-0">{children}</Dropdown.Menu>
    </Dropdown>
  );
}